import { useMemo, useRef, useState } from 'react'
import { Original } from 'src/common/Common.Type'
import BaseBtn from 'src/component/ActionBtn/BaseBtn'
import ReportsPagesContent from 'src/component/ReportsPagesContent'
import { GetPatientDecisions } from 'src/requests/PatientMedicalServices'
import MedicalServiceHistoryPopup from './Popup/MedicalServiceHistoryPopup'
import MedicalServicesPopup from './Popup/MedicalServicesPopup'
import { dateFormatter } from 'src/utils'

const AddMedicalService = () => {

  const [rowId, setRowId] = useState<number | null>(null)
  const [hospitalId, setHospitalId] = useState<number | null>(null)

  const medicalServiceHistoryRef = useRef<any>(null)
  const updateModalRef = useRef<any>(null)


  const columns = useMemo(() => [
    {
      Header: "patientName",
      accessor: "patientName"
    },
    {
      Header: "patientNationalId",
      accessor: "patientNationalId"
    },
    {
      Header: "diagnosis",
      accessor: "diagnosis"
    },
    {
      Header: "hospitalName",
      accessor: "hospitalName"
    },
    {
      Header: "decisionType",
      accessor: "decisionType"
    },
    {
      Header: "serviceType",
      accessor: "serviceType"
    },
    {
      Header: "lastDeliveryDate",
      Cell: ({ row: { original } }: Original) => (dateFormatter(original.lastDeliveryDate, "ar")),
    },
    {
      Header: "action",
      Cell: ({ row: { original } }: Original) => (
        <>
          <BaseBtn icon={"solar:eye-bold"} className='update' ApplyAction={() => handleModalView(original?.decisionId)} isDisabled={false} />
          <BaseBtn icon={"material-symbols:edit-sharp"} className='update' ApplyAction={() => handleUpdateModal(original?.decisionId, original?.hospitalId)} isDisabled={false} />
        </>
      )
    }
  ], [])

  const handleModalView = (id: number) => {
    setRowId(id)
    medicalServiceHistoryRef.current.click()
  }

  const handleUpdateModal = (id: number, hospitalId: number) => {
    setRowId(id)
    setHospitalId(hospitalId)
    updateModalRef.current.click()
  }

  return (
    <>
      <MedicalServicesPopup setDecisionId={setRowId} modalId={updateModalRef} decisionId={rowId} hospitalId={hospitalId} />
      <MedicalServiceHistoryPopup id={rowId} modalId={medicalServiceHistoryRef} />
      <ReportsPagesContent needParams columns={columns} tableAPI={GetPatientDecisions} />
    </>
  )
}

export default AddMedicalService